import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { applyMiddleware } from 'redux';
import configureStore from './utils/stores.js';
// import 'antd/dist/antd.css';
import './theme.less';
import './index.less';
import App from './pages/IndexRouter';
// import registerServiceWorker from './registerServiceWorker';
import { LocaleProvider } from 'antd';
import en_US from 'antd/lib/locale-provider/en_US';

const store = configureStore(applyMiddleware(thunk));

ReactDOM.render(
    <LocaleProvider locale={en_US}>
        <Provider store={store}>
            <App />
        </Provider>
    </LocaleProvider>,
    document.getElementById('root')
);

// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js